import gql from "graphql-tag";

import { Fragment, Skill } from "../types";

export const SKILL_FRAGMENT = gql`
  fragment SkillFragment on Skill {
    createdAt
    id
    kind
    locale
    name
    updatedAt
  }
`;

export type SkillFragment = Fragment<
  Skill,
  Pick<Skill, "createdAt" | "id" | "kind" | "locale" | "name" | "updatedAt">
>;
